import React from 'react';

import { isElectron } from 'src/hooks/useElectron';
import { useNativeNotifications } from 'src/hooks/useNativeNotifications';
import { useNotificationNavigation } from 'src/hooks/useNotificationNavigation';

/**
 * Component that initializes all Electron-specific integrations.
 * This should be rendered once at the app level, inside the Redux provider.
 *
 * Integrations:
 * - Badge count sync: Updates the dock badge with unread notification count
 * - Notification navigation: Handles clicks on native notifications
 */
export const ElectronIntegration: React.FC = () => {
  // Skip all hooks if not in Electron
  if (!isElectron()) {
    return null;
  }

  return <ElectronIntegrationInner />;
};

/**
 * Inner component that actually calls the hooks.
 * Separated to ensure hooks are only called when in Electron environment.
 */
const ElectronIntegrationInner: React.FC = () => {
  // Sync unread notification count to dock badge
  useNativeNotifications();

  // Handle clicks on native notifications
  useNotificationNavigation();

  return null;
};
